export const EXAMPLE_ROUTE_NAME = {
  DASHBOARD: 'dashboard',
}

export const AUTH_ROUTE_NAME = {
  SIGNIN: 'signin',
}

export const DASHBOARD_ROUTE_NAME = {
  DASHBOARD: 'dashboard',
}

export const PLAN_ROUTE_NAME = {
  PLAN: 'package-plans',
}

export const STORE_ROUTE_NAME = {
  STORE: 'store',
  STORE_DETAIL: 'store-detail',
}

export const USER_ROUTE_NAME = {
  USER: 'users',
}

export const SERVICE_ROUTE_NAME = {
  SERVICE: 'services',
}

export const FEATURE_ROUTE_NAME = {
  FEATURE: 'features',
}

export const PAYMENT_ROUTE_NAME = {
  PAYMENT: 'payment-methods',
}

export const DEFAULTSTORE_ROUTE_NAME = {
  DEFAULTSTORE: 'defaultstore',
}

export const DEFAULTSTAFF_ROUTE_NAME = {
  DEFAULTSTAFF: 'defaultstaff',
}

export const TRANSACTION_ROUTE_NAME = {
  TRANSACTION: 'transaction',
}

export const GLOBALCONFIG_ROUTE_NAME = {
  GLOBALCONFIG: 'globalconfig',
}

export const FEATURE_FLAG_ROUTE_NAME = {
  FEATURE_FLAG: 'feature-flags',
}

export const FORBIDDEN_ROUTE_NAME = {
  FORBIDDEN: 'forbidden',
}
